import React from 'react';
import styles from './style.css';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { displayIClassFilter } from './util';

/* eslint-disable */
const FundListFilter = ({
  assetClassToggleButtons,
  morningstarButtons,
  openToNewInvestorsButton,
  selectFundsButton,
  handleAssetClassToggleClick,
  handleMorningstarToggleClick,
  handleOpenToNewInvestorsButton,
  handleSelectFundsButton,
  iClassButton,
  investorClassButton,
  closedFundsButton,
  handleiClassButton,
  handleInvestorClassButton,
  handleClosedFundsButton,
  totalAmount,
  rewardsAvailable
}) => {
  return (
    <>
      <div className="fund-list-filter">
        <div className="filters-list-wrapper">
          <div className="assets-filter">
            <div className="filter-header">Choose an Asset Class</div>
            <div className="filter-button-container">
              {assetClassToggleButtons.map(({ name, active }, idx) => (
                <span className="filter-button">
                  <MFBeaconButton
                    data-no-warn
                    id="toggleAssetClassFilter"
                    data-name="toggleAssetClassFilter"
                    type="button"
                    key={name}
                    onClick={() => handleAssetClassToggleClick(idx)}
                    variant={active ? 'primary' : 'secondary'}
                    label={name}></MFBeaconButton>
                </span>
              ))}
            </div>
          </div>
          <div className="row-second">
            <div className="star-rating">
              <div className="filter-header">Morningstar Rating</div>
              <div className="filter-button-container">
                {morningstarButtons.map(({ name, active }, idx) => (
                  <span className="filter-button">
                    <MFBeaconButton
                      data-no-warn
                      id={`toggleMorningstarFilter-${name}`}
                      data-name={`toggleMorningstarFilter-${name}`}
                      type="button"
                      key={name}
                      onClick={() => handleMorningstarToggleClick(idx)}
                      variant={active ? 'primary' : 'secondary'}
                      label={name}></MFBeaconButton>
                  </span>
                ))}
              </div>
            </div>

            <div className="fund-attrs">
              <div className="filter-header">
                T. Rowe Price<sup>&reg;</sup> Select Funds
              </div>
              <div className="filter-button-container">
                <span className="filter-button">
                  <MFBeaconButton
                    data-no-warn
                    id="toggleSelectFundsFilter"
                    type="button"
                    onClick={handleSelectFundsButton}
                    variant={selectFundsButton.active ? 'primary' : 'secondary'}
                    label={selectFundsButton.name}></MFBeaconButton>
                </span>
              </div>
            </div>

            <div className="fund-attrs">
              <div className="filter-header">Fund Attributes</div>
              <div className="filter-button-container">
                <span className="filter-button">
                  <MFBeaconButton
                    data-no-warn
                    id="toggleInvestorClassFilter"
                    data-name="toggleInvestorClassFilter"
                    type="button"
                    onClick={handleInvestorClassButton}
                    variant={
                      investorClassButton.active ? 'primary' : 'secondary'
                    }
                    label={investorClassButton.name}></MFBeaconButton>
                </span>
                {displayIClassFilter(totalAmount, rewardsAvailable) && (
                  <span className="filter-button">
                    <MFBeaconButton
                      data-no-warn
                      id="toggleIClassFilter"
                      data-name="toggleIClassFilter"
                      type="button"
                      onClick={handleiClassButton}
                      variant={iClassButton.active ? 'primary' : 'secondary'}
                      label={iClassButton.name}></MFBeaconButton>
                  </span>
                )}
                <span className="filter-button">
                  <MFBeaconButton
                    data-no-warn
                    id="toggleClosedFundsFilter"
                    data-name="toggleClosedFundsFilter"
                    type="button"
                    onClick={handleClosedFundsButton}
                    variant={closedFundsButton.active ? 'primary' : 'secondary'}
                    label={closedFundsButton.name}></MFBeaconButton>
                </span>
                <span className="filter-button">
                  <MFBeaconButton
                    data-no-warn
                    id="toggleOpenToNewInvestorsFilter"
                    data-name="toggleOpenToNewInvestorsFilter"
                    type="button"
                    onClick={handleOpenToNewInvestorsButton}
                    variant={
                      openToNewInvestorsButton.active ? 'primary' : 'secondary'
                    }
                    label={openToNewInvestorsButton.name}></MFBeaconButton>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FundListFilter;
